<template>
  <div class="bg-white max-w-5xl rounded-md shadow-md mx-auto my-12">
    <h1 class="text-center p-4 text-xl text-gray-800">
      Welcome to Carthike! Let's get started
    </h1>
    <OnboardingPlans />
  </div>
</template>

<script>
import OnboardingPlans from "./OnboardingPlans.vue";

export default {
  name: "OnboardingPopup",
  components: {
    OnboardingPlans
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
